import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		width: 800px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 24px;

		& > h2 {
			${({theme}) => theme.font.large_bold};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 300px;
			height: 80vh;
			overflow: auto;
		}
	`,
	GiveDiv: styled.div`
		height: 40px;
		display: flex;
		justify-content: end;
		gap: 8px;
		margin-top: 24px;

		& > select {
			${({theme}) => theme.font.extra_small};
			width: 160px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 0 12px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				height: 40px;
			}
		}

		& > input {
			${({theme}) => theme.font.extra_small};
			width: 160px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 0 12px;
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			flex-wrap: wrap;
		}
	`,
}
export default Style
